import {ModuleWithProviders, NgModule} from '@angular/core';
import {
  NbActionsModule,
  NbButtonModule,
  NbContextMenuModule,
  NbIconModule,
  NbLayoutModule,
  NbMenuModule,
  NbSearchModule,
  NbSelectModule,
  NbSidebarModule,
  NbThemeModule,
  NbUserModule,
} from '@nebular/theme';
import {NbEvaIconsModule} from '@nebular/eva-icons';
import {NbSecurityModule} from '@nebular/security';

import {HeaderComponent, SearchInputComponent} from './components';
import {CapitalizePipe, NumberWithCommasPipe, PluralPipe, RoundPipe, TimingPipe} from './pipes';
import {OneColumnLayoutComponent} from './layouts';
import {DEFAULT_THEME} from './styles/theme.default';
import {SharedModule} from 'app/shared/shared.module';
import {ProductsSyncNavbarModule} from '../components/products-limit-navbar/products-sync-navbar.module';
import {SyncProductsLimitReachedModalModule} from '../modals/sync-products-limit-reached-modal/sync-products-limit-reached-modal.module';
import {FloatingActionsComponent} from 'app/shared/floating-actions/floating-actions.component';

const NB_MODULES = [
  NbLayoutModule,
  NbMenuModule,
  NbUserModule,
  NbActionsModule,
  NbSearchModule,
  NbSidebarModule,
  NbContextMenuModule,
  NbSecurityModule,
  NbButtonModule,
  NbSelectModule,
  NbIconModule,
  NbEvaIconsModule,
];
const COMPONENTS = [
  HeaderComponent,
  SearchInputComponent,
  OneColumnLayoutComponent,
];
const PIPES = [
  CapitalizePipe,
  PluralPipe,
  RoundPipe,
  TimingPipe,
  NumberWithCommasPipe,
];

@NgModule({
  declarations: [
    ...COMPONENTS,
    ...PIPES,
  ],
  imports: [
    ...NB_MODULES,
    SharedModule,
    ProductsSyncNavbarModule,
    SyncProductsLimitReachedModalModule,
    FloatingActionsComponent,
  ],
  exports: [
    ...PIPES,
    ...COMPONENTS,
    FloatingActionsComponent,
  ],
})
export class ThemeModule {
  static forRoot(): ModuleWithProviders<ThemeModule> {
    return {
      ngModule: ThemeModule,
      providers: [
        ...NbThemeModule.forRoot(
          {
            name: 'default',
          },
          // [DEFAULT_THEME, COSMIC_THEME, CORPORATE_THEME, DARK_THEME],
          [DEFAULT_THEME],
        ).providers,
      ],
    };
  }
}
